module.exports = __webpack_public_path__ + "img/Rectangle.533b7e91.png";